<template>
  <div>
      <div class="money-pannel">
            <div class="money">
                <div class="nums">{{ info.total_settlement_amount || 0.0 }}</div>
                <div class="title">
                    <!-- 累计赚得  -->
                    {{$t('accumulated')}}
                </div>
            </div>
            <div class="money">
                <div  class="nums">{{ info.settlement_amount || 0.0 }}</div>
                <div class="title">
                    <!-- 已结算 -->
                    {{$t('settled')}}
                </div>
            </div>
            <div class="money">
                <div  class="nums">{{ userInfo.commission || 0.0 }}</div>
                <div class="title">
                    <!-- 可提现金额 -->
                    {{$t('withdrawableCash')}}
                </div>
            </div>
            <div class="money" @click="apply">
                <div class="btn">
                    <!-- 申请提现 -->
                    {{$t('applyForWithdrawal')}}
                </div>
            </div>
      </div>

    <div class="form-wrap">
        <el-input class="input mgr10" v-model="keyword" placeholder="请输入内容" clearable></el-input>
        <el-button type="danger" @click="search">搜索</el-button>
    </div>



      <!-- 推广的订单 -->
      <div class="table" >
        <el-table
        :empty-text="$t('noData')"
        :data="tableData"
        style="width: 100%">
        <el-table-column
            width="180"
            prop="ctime"
            :label="$t('inviteTime')">
        </el-table-column>
        <el-table-column
            prop="user"
            :label="$t('nickname')"
           >
        </el-table-column>
        <el-table-column
            prop="mobile"
            :label="$t('mobilenumber')"
            >
        </el-table-column>
       
        </el-table>
      </div>

      <Pagination
        v-if="tableData.length>0"
        :totalPage="totalPage"
        :limit="limit"
        @changePage="handleCurrentChange"
      ></Pagination>


       <el-dialog
            title="佣金提现"
            :visible.sync="dialogVisible"
            width="30%">
            <div class="dia-wrap">
                <el-input class="input" type="number" v-model="money" placeholder="请填写提现金额"></el-input>
            </div>
            <div class="dia-desc">最低提现佣金0.01, 可提现佣金{{ userInfo.commission || 0.0 }}</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="agree">确认</el-button>
            </span>
        </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/common/Pagination.vue";

export default {
    components: {
        Pagination
    },
    data() {
        return {
            info: {},
            userInfo: {},
            tableData: [],
            limit: 10,
            page: 1,
            totalPage: 0,
            keyword: '',
            dialogVisible: false,
            money: ''
        }
    },
    created() {
        this.init()
        this.tableList()
        // 获取用户信息
        this.$api.userInfo().then(res => {
            if(res.status) {
                this.userInfo = res.data
            }
        })
    },
    methods: {
        agree() {
            this.$api.StaffCash({
                money: this.money,
                type: 1
            }).then((res) =>{
                this.$message({
                    message: res.msg || '',
                    type: res.status ? 'success' : 'error'
                })
                if(res.status) {
                    this.money = ''
                    this.dialogVisible = false
                }
            })
        },
        search() {
            this.page = 1
            this.tableList()
        },
        // 申请提现跳转
        apply() {
            this.dialogVisible = true
            // this.$router.push({
            //     path: '/center/withdrawCash'
            // })
        },
        // 表格分页
        handleCurrentChange() {
            this.page += 1
            this.tableList()
        },
        // 推广订单数据
        tableList() {
            let data = {
                page: this.page,
                limit: this.limit
            }
            this.keyword && (data.keyword = this.keyword)

            this.$api.channelbusinessGetorder(data).then(res =>{
                if(res.status) {
                    this.tableData = res.data.list
                    this.totalPage = Math.ceil(res.data.count / this.limit) 
                }
            })
        },
        init() {
            this.$api.distributionCenter().then(res =>{
                if(res.status && res.data.verify == 1) {
                    this.info = res.data
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.dia-wrap {
    margin: 20px 20px;
    
}
.dia-desc {
    padding-left: 20px;
}
.money-pannel {
    margin-top: 10px;
    overflow: hidden;
    border: 1px solid #ffccbc;
    border-top: 5px solid #ffccbc;
    padding: 20px 0;
    .money {
        float: left;
        width: 25%;
        border-right: 1px solid #fbe9e7;
        text-align: center;
        margin: -1px;
        font-size: 32px;
        color: #ff5722;
        cursor: pointer;
        .nums {
            font-weight: bold;
            float: none;
            margin-left: 0px;
            color: #ff5722;
            font-size: 32px;
            border: 0;
        }
        .title {
            font-weight: normal;
            font-size: 14px;
            color: #666;
            width: 100%;
            display: inline-block;
        }
        .btn {
            width: 170px;
            height: 40px;
            text-align: center;
            line-height: 40px;
            background: #ff5722;
            color: #fff;
            display: inline-block;
            font-size: 16px;
            border-radius: 4px;
        }
    }
}


.form-wrap {
    margin: 20px 0;
    .input {
        width: 300px;
        margin-right: 10px;
    }
}


</style>